import React from 'react';

export const BtnNguonKhachHang = ({ onClick }) => {
    return (
        <button
            type="button"
            className="btn btn-border-new"
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                border: 'none',
                padding: 0,
                gap: '6px',
                backgroundColor: 'transparent',
                color: '#2B335E',
                cursor: 'pointer'
            }}
        >
            <img
                src="/app-assets/images/icon-nguon-khach-hang.png"
                alt="Nguồn KH"
                className="icon-button-v2"
                style={{ width: '22px', height: 'auto', display: 'block' }}
            />
            <span style={{
                fontSize: '16px',
                lineHeight: '1',
                marginTop: '2px',
            }}>
                Nguồn khách hàng
            </span>
        </button>
    );
};